import { useEffect, useState, useContext } from 'react';

import { ScrollContext } from '../components/Layout/ScreenContainer';

export interface UseScrollEffectInterface {
  (
    /**
     * At which point do we trigger a change of the scrolled state
     * @default 200
     */
    scrolledThreshold?: number,

    /**
      * Difference in pixel between the scrolledThreshold and the point
      * where we go back to the non-scrolled state, this is used to avoid flickering.
      * @default 50
      */
    debounceThreshold?: number 
  ): boolean
}

const useScrollEffect: UseScrollEffectInterface = (
  scrolledThreshold = 200,
  debounceThreshold = 50
) => {
  const scrollY = useContext(ScrollContext);
  const [ scrolled, setScrolled ] = useState(false);

  useEffect(() => {
    if (scrollY < scrolledThreshold - debounceThreshold) {
      setScrolled(false);
    }

    if (scrollY > scrolledThreshold) {
      setScrolled(true);
    }
  }, [scrollY]);

  return (scrolled);
}

export default useScrollEffect;